import { Subscription } from "rxjs";
import { BaseCommandProvider } from "common/app/command-palette/providers/base-provider";
import { Command, ProviderConfig } from "common/app/command-palette/types";
import { eventBus } from "common/event-bus";

function AddPaletteCommands(commands: Command[], contextCommands: Command[]) {
  const newCommandIds = new Set(contextCommands.map((c) => c.id));

  const filteredOptions = commands.filter(
    (command) => !newCommandIds.has(command.id),
  );

  return [...filteredOptions, ...contextCommands];
}

function RemovePaletteCommands(commands: Command[], contextCommands: string[]) {
  const commandIdsToRemove = new Set(contextCommands);
  return commands.filter((command) => !commandIdsToRemove.has(command.id));
}

export class ContextProvider extends BaseCommandProvider {
  private commands: Command[] = [];

  private readonly addCommandsSubscription: Subscription;
  private readonly removeCommandsSubscription: Subscription;

  constructor(config: ProviderConfig) {
    super(config);

    this.addCommandsSubscription = eventBus.on(
      "AddPaletteCommands",
      (contextCommands) => {
        this.commands = AddPaletteCommands(this.commands, contextCommands);
        this.onCommandsChanged();
      },
    );
    this.removeCommandsSubscription = eventBus.on(
      "RemovePaletteCommands",
      (contextCommands) => {
        this.commands = RemovePaletteCommands(this.commands, contextCommands);
        this.onCommandsChanged();
      },
    );
  }

  dispose() {
    this.addCommandsSubscription?.unsubscribe();
    this.removeCommandsSubscription?.unsubscribe();
  }

  getCommands(): Command[] {
    return this.commands.map((command) => ({
      ...command,
      id: `context:${command.id}`,
      category: "action",
    }));
  }
}
